// extracted by mini-css-extract-plugin
module.exports = {"listAvatar":"Home_listAvatar__17Zyh","listItem":"Home_listItem__s83jX"};